var $,
  pagination_success = false;

/*
 * Show/hide map (mobile)
 *
 * @return {void}
*/
function showHideFiltersMapMobile () {
  var show_filters_map = '.show-filters-map',
    main_map = '.main-map';

  $(show_filters_map).on('click', function(e) {
    e.preventDefault();

    enableScrollLock();

    $(main_map).show(0, function() {
      window.dispatchEvent(new Event('resize'));
    });
  });
}

/**
 * Close map view (mobile)
 *
 *
 * @return {void}
 */
function closeMapMobile () {
  var close_map = '.map-container__close-button',
    main_map = '.main-map';

  $(close_map).on('click', function() {
    disableScrollLock();
    $(main_map).hide();
  });
}

/*
 * Show/hide filters (mobile)
 *
 * @return void
*/
function showHideFiltersMobile () {
  var show_filters = '.show-filters',
    filters_row = '.show-filters-hidden',
    show = $(show_filters).data('show'),
    hide = $(show_filters).data('hide'),
    show_filters_text;

  $(document).off('click').on('click', show_filters, function (e) {
    e.preventDefault();

    show_filters_text = $(filters_row).is(':visible') ? show : hide;
    $(e.currentTarget).children('span').text(show_filters_text);

    if ($(filters_row).is(':visible')) {
      $(filters_row).hide();

      return;
    }

    $(filters_row).show();
  });
}

/**
* Show loader on load more
* adapt for search results
*
* @return void
 */
function showLoadMoreSpinner () {
  var loader = '.load-more-spinner',
    load_more_button = '.listing-load-more .ajax';

  $(load_more_button).on('click', function () {
    $(loader).fadeIn(300);
    $(this).hide();
  });

}

/**
* Call the noUiRangeSlider script,
* adapt for search results
*
* @return void
 */
function noUiRangeSlider (slider) {
  var min_value = $(slider).data('min') || 0,
    max_value = $(slider).data('max') || 0,
    start_value_left = $(slider).data('start-left') || min_value,
    start_value_right = $(slider).data('start-right') || max_value,
    min_input = $(slider).parent().find('.nouislider-min-value'),
    max_input = $(slider).parent().find('.nouislider-max-value'),
    step = $(slider).data('step'),
    name = $(slider).data('name');

  noUiSlider.create(slider, {
    start: [start_value_left, start_value_right],
    step: step || 1,
    decimals: 0,
    range: {
      'min': min_value,
      'max': parseInt(min_value) === parseInt(max_value) ? parseInt(max_value) + 1 : parseInt(max_value),
    },
    tooltips: true,
    connect: true,
    format: {
      /* Content after to value */
      to: function (value) {
        return parseInt(value) || '0';
      },
      /* Content after from value */
      from: function (value) {
        return parseInt(value.replace('', ''));
      }
    }
  });

  slider.noUiSlider.on('update', function (values, handle) {
    if (handle) {
      var ext = '',
        max,
        input_field_max;

      if (name === 'parcel_unit_size') {
        max = 5000;

        if (parseInt(values[handle]) === max) {
          ext = '+';
        }

        max_input.html(parseInt(values[handle]) + ext);
      } else if (name === 'sea_distance' || name === 'airport_distance' || name === 'town_distance' || name === 'restaurant_distance') {
        if (name === 'restaurant_distance') {
          max = 5000;

          if (parseInt(values[handle]) === max) {
            ext = '+';
          }
        }
        max_input.html(formatDistance(values[handle], ext));
      } else {
        max_input.html(parseInt(values[handle]));
      }

      input_field_max = '#' + name + '_max';
      $(input_field_max).val(parseInt(values[handle]) + ext);

    } else {
      if (values[handle] === '') {
        values[handle] = 0;
      }

      if (name === 'sea_distance' || name === 'airport_distance' || name === 'town_distance' || name === 'restaurant_distance') {
        min_input.html(formatDistance(values[handle], ''));
      } else {
        min_input.html(parseInt(values[handle]));
      }

      var input_field_min = '#' + name + '_min';

      $(input_field_min).val(parseInt(values[handle]));
    }
  });

  slider.noUiSlider.on('change', function (values, handle) {
    var filter_field = '#' + name + '_filter';

    if (handle) {
      if (max_value !== parseInt(values[handle])) {
        $(filter_field).val(true);
      }
    } else {
      if (min_value !== parseInt(values[handle])) {
        $(filter_field).val(true);
      }
    }
  });
}
function formatDistance(value, ext = '') {
  const formatNumber = (num, decimals = 0) =>
      new Intl.NumberFormat(undefined, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(num);

  if (value < 1000) {
    return `${formatNumber(Math.round(value))}m${ext}`;
  }

  const km = value / 1000;

  if (km < 10) {
    return `${formatNumber(km, 1)}km${ext}`;
  }

  return `${formatNumber(Math.round(km))}km${ext}`;
}
/*
* Show main listing loader
*
* @return void
 */
function showMainListingLoader (success) {
  var main_loader = '.main-loader',
    pagination_item = '.listing-pagination-item',
    listing_items_container = '.listings-container.listing-container--search-results',
    header_container = '.header-container',
    html_body = 'html, body';

  if(success) {
    $(main_loader).show();
    setTimeout(function () {

      if ($(window).width() <= 768) {
        $(html_body).animate({
          scrollTop: $(listing_items_container).offset().top - 100
        }, 800);

      } else {
        $(html_body).scrollTop(
          $(listing_items_container).offset().top - $(header_container).outerHeight()
        );

        $(html_body).delay(400).animate({
          scrollTop: $(this).scrollTop() - 50
        }, 300);
      }

      $(main_loader).delay(1000).fadeOut(250);

    }, 700);
  }

  $(pagination_item).on('click', function () {
    $(main_loader).fadeIn(250);
  });
}

/**
* Search map manipulation on scroll
*
* @return void
 */
function positionSearchMapOnScroll () {
  var map_scroll_stopper = '#footer',
    wi = $(window).width();

  if ($(map_scroll_stopper).length > 0 && wi > 991) {
    // Triggers the window scroll
    $(window).scroll();

    var map_block = '.main-map',
      map_not_fixed = 'map-not-fixed',
      map_blocker_position,
      bottom_viewport = $(window).scrollTop() + $(window).height();

    $(window).on('load resize scroll', function () {
      $(map_block).css({'height': '100vh'});
      $(map_block).removeClass(map_not_fixed).css({'top': '0'});
      bottom_viewport = $(window).scrollTop() + $(window).height();
      map_blocker_position = $(map_scroll_stopper).offset().top - $(map_block).outerHeight() - $('.header-container').outerHeight();

      
      if($(window).scrollTop() < $('.header-container').outerHeight()) {
        $(map_block).css({'margin-top': $('.header-container').outerHeight() - $(window).scrollTop() + 'px'});
        $(map_block).css({'height': `calc(100vh - ${$('.header-container').outerHeight() - $(window).scrollTop() + 'px'})`});
      }else {
        $(map_block).css({'margin-top': '0'});
      }

      if (bottom_viewport > $(map_scroll_stopper).offset().top) {
        $(map_block).css({'top': map_blocker_position + 145 + 'px'});
        $(map_block).addClass(map_not_fixed);
      }

      // if modal is opened give the map a margin top
      if($('.modal-general-opened')[0]) {
        $(map_block).css({'height': '100vh'});
        $(map_block).css({'margin-top': '0'});
        if (bottom_viewport > $(map_scroll_stopper).offset().top) {
          $(map_block).css({'top': map_blocker_position + 145 + 'px'});
          $(map_block).removeClass(map_not_fixed);
        }
      }

    });
  }
}

function hide_show_pets_number_field () {
  var element = document.getElementById('inquiry-pets-number'),
    elements,
    pets_number;

  if (element !== null && element !== 'undefined') {
    pets_number = parseInt(element.value);

    if (pets_number !== 0) {
      elements = document.getElementsByClassName('checkboxes-pets-number');

      for (var i = 0; i < elements.length; ++i) {
        var el = elements[i];
        el.classList.remove('hidden');
      }
    }
  }
}


function showFilteringLoader () {
  var filtering_page_loader = '.page-loader--filtering-results',
    apply_filter_button = '.panel-buttons .panel-apply';
  $(apply_filter_button).on('click', function () {
    $(filtering_page_loader).fadeIn(300);
    $('html, body').animate({
      scrollTop: 0
    }, 800);
  });
}

function submitForm (value) {
  document.getElementById('sort_type').value = value;
  $('#frm-searchResultsControl-filterFormControl-filterForm').submit();
}

$(document).ready(function () {
  $('.nouislider').each(function (index, item) {
    noUiRangeSlider(item);
  });

  /* Half Screen Map Adjustments */
  $(window).on('load resize', function () {
    var winWidth = $(window).width();

    if (winWidth < 1025) {
      $('.fs-inner-container.map-fixed').insertBefore('.fs-inner-container.content');
    } else {
      $('.fs-inner-container.content').insertBefore('.fs-inner-container.map-fixed');
    }
  });

  showMainListingLoader();
  showLoadMoreSpinner();
  showHideFiltersMobile();
  showHideFiltersMapMobile();
  closeMapMobile();
  positionSearchMapOnScroll();
  hide_show_pets_number_field();
  setSelectedSortOption();
  showFilteringLoader();
});
